import React, { useState } from 'react';

const TeamForm = ({ onSubmit, onCancel, initialName = '', submitLabel = 'Create Team', loading = false }) => {
  const [teamName, setTeamName] = useState(initialName);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (teamName.trim() && !loading) {
      onSubmit(teamName.trim());
      setTeamName('');
    }
  };

  return (
    <div className="bg-blue-50 p-4 rounded-lg">
      <h4 className="font-medium text-gray-700 mb-3">Create New Team</h4>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="text"
          placeholder="Team Name"
          value={teamName}
          onChange={(e) => setTeamName(e.target.value)}
          disabled={loading}
          className={`w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
          autoFocus
        />
        <div className="flex space-x-2">
          <button
            type="submit"
            disabled={!teamName.trim() || loading}
            className="flex-1 bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            {loading ? 'Creating...' : submitLabel}
          </button>
          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              disabled={loading}
              className={`px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
                            Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default TeamForm;

